export default __webpack_public_path__ + "static/media/freedatajs.11b8f970.PNG";